import CardItem from "components/alove/CardItem";
import { ActionSetting } from "layouts/screens/screenView/components/action";
import React, { useEffect, useState } from "react";
import { Action, ChatMessage, Comm, LoraMessageType } from "models/content/Comm";
import { ScreenModel } from "models/content/Screen";
import { Grid, IconButton, Autocomplete } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { DropdownButton } from "components/alove/DropDownButton";
import { questionsListDO } from "utils/questionsUtils";
import { BatchCode } from "models/batch/Batch";
import { BatchContent } from "models/batch/BatchContent";
const MDInput = require("components/MDInput/index.js").default;

export const ChatContainer = ({
  comm,
  setComm,
  screens,
}: {
  comm: Comm;
  setComm: any;
  screens: ScreenModel[];
}) => {
  const [questions, setQuestions] = useState<BatchContent[]>([]);

  useEffect(() => {
    if (!comm.chat?.expirationDate) {
      setComm({
        ...comm,
        chat: {
          ...comm.chat,
          messages: comm.chat?.messages || [],
          expirationDate: new Date(Date.now() + 30*24*60*60*1000).toISOString().split('T')[0]
        }
      });
    }
  }, [comm.chat]);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const questionsList = await questionsListDO(BatchCode.otherQuestions);
        setQuestions(questionsList);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };
    fetchQuestions();
  }, []);

  const addNewMessage = () => {
    setComm({
      ...comm,
      chat: {
        ...comm.chat,
        messages: [...(comm.chat?.messages || []), { body: '', questionId: 0, type: LoraMessageType.Text }]
      }
    });
  };

  const updateMessage = (index: number, value: string) => {
    const newMessages = [...(comm.chat?.messages || [])] as ChatMessage[];
    const message = { ...newMessages[index] };
    
    if (message.type === LoraMessageType.Question) {
      message.questionId = parseInt(value) || 0;
      message.body = '';
    } else {
      message.body = value;
      message.questionId = 0;
    }
    
    newMessages[index] = message;
    setComm({
      ...comm,
      chat: {
        ...comm.chat,
        messages: newMessages
      }
    });
  };

  const updateMessageType = (index: number, type: LoraMessageType) => {
    const newMessages = [...(comm.chat?.messages || [])] as ChatMessage[];
    newMessages[index] = { body: '', questionId: 0, type };
    setComm({
      ...comm,
      chat: {
        ...comm.chat,
        messages: newMessages
      }
    });
  };

  const deleteMessage = (index: number) => {
    const newMessages = [...(comm.chat?.messages || [])] as ChatMessage[];
    newMessages.splice(index, 1);
    setComm({
      ...comm,
      chat: {
        ...comm.chat,
        messages: newMessages
      }
    });
  };

  return (
    <React.Fragment>
      <CardItem title="Edit Chat Messages" id="comm" halfWidth>
        <Grid container spacing={2} flexDirection="column">
          {(comm.chat?.messages || []).map((message, index) => (
            <Grid container key={index} spacing={1} alignItems="flex-start">
              <Grid size={3}>
                <DropdownButton
                  options={[
                    { label: 'Text', value: LoraMessageType.Text.toString() },
                    { label: 'Question', value: LoraMessageType.Question.toString() }
                  ]}
                  value={message.type.toString()}
                  onClick={(option) => updateMessageType(index, parseInt(option.value) as LoraMessageType)}
                />
              </Grid>
              <Grid size={8}>
                {message.type == LoraMessageType.Question ? (
                  <Autocomplete
                    options={questions}
                    getOptionLabel={(option) => option.question.txtId || ''}
                    value={questions.find(q => q.id == message.questionId) || null}
                    onChange={(_, newValue) => {
                      updateMessage(index, newValue?.id.toString() || '0');
                    }}
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        label="Select Question"
                        fullWidth
                      />
                    )}
                  />
                ) : (
                  <MDInput
                    label="Message"
                    value={message.body}
                    fullWidth
                    multiline
                    onChange={(e) => updateMessage(index, e.target.value)}
                  />
                )}
              </Grid>
              <Grid size={1}>
                <IconButton onClick={() => deleteMessage(index)} color="error">
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          <Grid>
            <IconButton onClick={addNewMessage} color="primary">
              <AddIcon />
            </IconButton>
          </Grid>
          <Grid size={4}>
            <MDInput
              label="Expiration Date"
              type="date"
              value={comm.chat?.expirationDate}
              fullWidth
              onChange={(e) => {
                setComm({ ...comm, chat: { ...comm.chat, expirationDate: e.target.value } });
              }}
            />
          </Grid>
        </Grid>
      </CardItem>
      {/* <CardItem title="Chat Link" id="comm" halfWidth>
        <ActionSetting
          action={comm.chat || {} as Action}
          setAction={(a) => setComm({ ...comm, chat: a })}
          screens={screens}
        />
      </CardItem> */}
    </React.Fragment>
  );
};
